import React from 'react'
import { useTranslation } from 'react-i18next'

const StarScoringCard = (_props) => {
  const { t } = useTranslation()
  return (
    <div className='d-flex align-items-center'>
      <div
        className='d-flex align-items-center'
        style={{ color: '#34ACE0', fontSize: 18 }}
      >
        {[0, 1, 2, 3, 4].map((num) => (
          // eslint-disable-next-line react/jsx-key
          <i
            className={`fa fa-star${num > 1 ? '-o' : ''}`}
            aria-hidden='true'
            style={{ marginRight: 2 }}
          />
        ))}
      </div>
      <div style={{ marginLeft: 4 }}>
        <p className='mb-0' style={{ lineHeight: 1.2 }}>
          {t('drills.starScoringCard.starFeedback')}
        </p>
        <p className='mb-0' style={{ lineHeight: 1.2 }}>
          {t('drills.starScoringCard.feedbackExample')}
        </p>
      </div>
    </div>
  )
}

export default StarScoringCard
